////
/// ============================================================================
/// COMPONENT / Product Stores
/// ============================================================================
///
/// @group components
////

export default () => {
    document.querySelectorAll(".js-tabs").forEach((container) => {
        container.addEventListener("tab-activated", (event) => {
            const tab = event?.detail?.tab;
            const panel = document.querySelector(".js-wp-store-locator");

            if (tab && panel && window.initWpslMap && "tab-stores" === tab.getAttribute("aria-controls")) {
                fetch(panel.dataset.url)
                    .then(response => response.text())
                    .then((html) => {
                        panel.innerHTML = html;
                        initWpslMap();
                    });
            }
        });
    });
};
